import React, { useEffect, useState } from "react";
import styled from "styled-components";

import {
  Curve,
  Time as TimeIcon,
  ProfileIcon,
} from "../../../../components/svgs";
import {
  Body,
  Children,
  CurveHolder,
  MainHolder,
  StyledText,
} from "../../../../components/common/basic";
import loadingGif from "../../../../components/images/loader.gif";

import { BackButton } from "../../../../components/common";

// hooks
import { useSubscriber } from "../../../../hooks";
import useSpeedShoppingPoints from "../../speedShopping/hooks/useSpeedShoppingPoints";

function ordinalOf(i) {
  if (!i) return i;
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}

const Leaderboard = ({ backAction }) => {
  const {
    background,
    history,
    userPoints,
    topLoyaltyList,
    getTopLoyaltyList,
    getLoyaltyPoints,
  } = useSpeedShoppingPoints();

  const { userhandle } = useSubscriber();

  useEffect(() => {
    getTopLoyaltyList({ payload: {} });
    getLoyaltyPoints({ payload: {} });
  }, []);

  const [isOn, toggleSwitchState] = useState(false);
  const [activeRankings, setActiveRankings] = useState([]);
  const [myRanking, setMyRanking] = useState({});

  const { historyRounded, pointsRounded, rank, msisdn } = userPoints || {
    pointsRounded: 0,
    historyRounded: [],
    msisdn: "",
    rank: 0,
  };

  return (
    <>
      <MainHolder style={{ background: "#F2F2F2" }}>
        <Children>
          <Header background={background}>
            <BackButton
              onClick={() => {
                backAction ? backAction() : history.push("/spin_the_wheel");
              }}
            />
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <StyledText
                style={{ fontFamily: "MTNRegular" }}
                size={24}
                margin='0'
                color='white'
              >
                Leaderboard
              </StyledText>
            </div>
            <BoxSwitch
              onLabel={"Ranking"}
              offLabel={"All time"}
              background={background}
              isOn={isOn}
              onToggle={toggleSwitchState}
            />
          </Header>
          <LargeRankCard
            background={background}
            points={pointsRounded}
            rank={ordinalOf(rank || 0)}
            msisdn={msisdn}
            userhandle={userhandle}
          />
          <Body>
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              {
                (!topLoyaltyList || !topLoyaltyList.length) ?
                  <div style={{ textAlign: "center" }}>
                    <img
                      alt={"dialog"}
                      src={loadingGif}
                      style={{ display: "block", width: "40px", margin: "0 auto" }}
                    />
                    <StyledText>Fetching ranking data...</StyledText>
                  </div>
                  :
                  <>
                    {topLoyaltyList.map((rankData, index) => {
                      const rankFmt = ordinalOf(index + 1);
                      return (
                        <RankCard
                          background={background}
                          {...rankData}
                          rank={rankFmt}
                          mymsisdn={msisdn}
                        />
                      );
                    })}
                  </>
              }

            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const BoxSwitch = ({ onLabel, offLabel, onToggle, background, isOn }) => {
  const buttonStyle = {
    flexGrow: 1,
    borderRadius: "5px",
    padding: "10px",
    textAlign: "center",
    background: "none",
  };
  const activeButtonStyle = { ...buttonStyle, background };
  return (
    <div
      onClick={() => {
        // onToggle(!isOn);
      }}
      style={{
        cursor: "pointer",
        fontFamily: "MTNRegular",
        color: "#fff",
        display: "flex",
        width: "230px",
        margin: "0 auto",
        borderRadius: "5px",
        fontSize: "12px",
        background: "rgba(0,0,0,0.6)",
        padding: "3px",
      }}
    >
      <div style={isOn ? activeButtonStyle : buttonStyle}>{onLabel}</div>
      <div style={!isOn ? activeButtonStyle : buttonStyle}>{offLabel}</div>
    </div>
  );
};

const RankCard = ({ rank, msisdn, points, background, mymsisdn }) => {
  const columnStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div
      style={{
        padding: "8px 3px",
        borderRadius: "10px",
        background: msisdn === mymsisdn ? background : "#fff",
        position: "relative",
        display: "flex",
        maxWidth: "325px",
        zIndex: 2,
        margin: "0 auto 10px auto",
      }}
    >
      <div style={{ ...columnStyle, width: "40px" }}>
        <StyledText
          color={msisdn === mymsisdn ? "white" : "black"}
          margin={0}
          size={14}
          style={{ fontFamily: "MTNBold" }}
        >
          {rank}
        </StyledText>
      </div>
      <div style={{ width: "50px", ...columnStyle }}>
        <div
          style={{
            width: "35px",
            background: "#fff",
            height: "35px",
            borderRadius: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #000",
            overflow: "hidden",
          }}
        >
          <ProfileIcon width={20} height={20} />
        </div>
      </div>
      <div style={{ flexGrow: 1, ...columnStyle }}>
        <StyledText
          color={msisdn === mymsisdn ? "white" : "black"}
          margin={0}
          size={14}
          style={{ fontFamily: "MTNBold" }}
        >
          {msisdn === mymsisdn ? msisdn : `xxxx-xxx-${msisdn.substr(9)}`}
        </StyledText>
      </div>
      <div style={{ width: "85px", ...columnStyle }}>
        <StyledText
          color={msisdn === mymsisdn ? "white" : background}
          margin={0}
          size={14}
          style={{ fontFamily: "MTNBold" }}
        >
          {points?.toLocaleString()}pts
        </StyledText>
      </div>
    </div>
  );
};

const LargeRankCard = ({ background, points, rank, msisdn, userhandle }) => {
  return (
    <div
      style={{
        padding: "5px 3px",
        borderRadius: "10px",
        background: "#fff",
        margin: "20px auto -80px auto",
        position: "relative",
        display: "flex",
        boxShadow: "0 0 13px rgba(0,0,0,0.2)",
        width: "280px",
        top: "-90px",
        zIndex: 2,
      }}
    >
      <div
        style={{
          width: "33%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <StyledText margin={0} size={10} style={{ fontFamily: "MTNRegular" }}>
          Rank
        </StyledText>
        <StyledText margin={0} size={24} style={{ fontFamily: "MTNBold" }}>
          {rank || "-"}
        </StyledText>
      </div>
      <div style={{ width: "34%" }}>
        <div
          style={{
            textAlign: "center",
            position: "relative",
            top: "-15px",
            marginBottom: "-10px",
          }}
        >
          <div
            style={{
              width: "55px",
              background: "#fff",
              height: "55px",
              borderRadius: "100px",
              margin: "0 auto 5px auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #000",
              overflow: "hidden",
            }}
          >
            <ProfileIcon width={20} height={20} />
          </div>
          <StyledText margin={0} size={12} style={{ fontFamily: "MTNRegular" }}>
            {userhandle}
          </StyledText>
          <StyledText
            margin={0}
            size={10}
            color={background}
            style={{ fontFamily: "MTNRegular" }}
          >
            {`0${msisdn.replace("+", "").substr(3)}`}
          </StyledText>
        </div>
      </div>
      <div
        style={{
          width: "33%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <StyledText margin={0} size={10} style={{ fontFamily: "MTNRegular" }}>
          Points
        </StyledText>
        <StyledText margin={0} size={24} style={{ fontFamily: "MTNBold" }}>
          {points?.toLocaleString()}
        </StyledText>
      </div>
    </div>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 80px 20px;
  background-color: ${({ background }) => background};
  position: relative;
  margin-bottom: 35px;
`;

export default Leaderboard;
